import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { Permission } from "./core/permission/enums/permission.enum";

import { PATHS } from "@app/core/constants/path.const";
import { AuthGuard, mustChangePasswordGuard } from "@app/core/guards";
import { NotFoundComponent } from "@app/core/pages/not-found/not-found.component";
import { LayoutComponent } from "@app/shared/components/layout/layout.component";

const routes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [mustChangePasswordGuard],
    data: { label: "BREADCRUMBS.HOME" },
    component: LayoutComponent,
    children: [
      {
        path: "",
        redirectTo: PATHS.policies.path,
        pathMatch: "full",
      },
      {
        path: PATHS.home.path,
        loadChildren: () => import("@app/features/home/home.module").then(m => m.HomeModule),
      },
      {
        path: PATHS.clients.path,
        data: { label: "BREADCRUMBS.CLIENTS", permission: Permission.VIEW_CLIENTS },
        loadChildren: () => import("@app/features/clients/clients.module").then(m => m.ClientsModule),
      },
      {
        path: PATHS.policies.path,
        data: { label: "BREADCRUMBS.POLICIES", permission: Permission.VIEW_POLICIES, key: "policies-module" },
        loadChildren: () => import("@app/features/policies/policies.module").then(m => m.PoliciesModule),
      },
      {
        path: PATHS.quote.path,
        data: { label: "BREADCRUMBS.QUOTES" },
        loadChildren: () => import("@app/modules/quote/quote.module").then(m => m.QuoteModule),
      },
      {
        path: PATHS.claims.path,
        data: { label: "BREADCRUMBS.CLAIMS", permission: Permission.VIEW_CLAIMS },
        loadChildren: () => import("@app/modules/claims/claims.module").then(m => m.ClaimsModule),
      },
      {
        path: PATHS.product.path,
        data: { label: "BREADCRUMBS.PRODUCTS", permission: Permission.VIEW_PRODUCTS },
        loadChildren: () => import("@app/features/product/product.module").then(m => m.ProductModule),
      },
      {
        path: PATHS.settings.path,
        data: { label: "BREADCRUMBS.SETTINGS"},
        loadChildren: () => import("@app/features/settings/settings.module").then(m => m.SettingsModule),
      },
      {
        path: PATHS.profile.path,
        data: { label: "BREADCRUMBS.MY_PROFILE" },
        loadChildren: () => import("@app/features/user-profile/user-profile.module").then(m => m.UserProfileModule),
      },
      {
        path: PATHS.forcePasswordChange.path,
        data: { label: "BREADCRUMBS.FORCE_PASSWORD_CHANGE" },
        loadChildren: () =>
          import("@app/features/auth/pages/force-password-change/force-password-change.module")
            .then(m => m.ForcePasswordChangeModule),
      },
      {
        path: PATHS.billing.path,
        data: { label: "BREADCRUMBS.BILLING" },
        loadChildren: () => import("@app/features/billings/billings.module").then(m => m.BillingsModule),
      },
      {
        path: PATHS.lossRunIntelligence.path,
        data: { label: "BREADCRUMBS.LOSS_RUN_INTELLIGENCE" },
        loadChildren: () =>
          import("@app/features/loss-run-intelligence/loss-run-intelligence.module").then(
            m => m.LossRunIntelligenceModule
          ),
      },
      {
        path: PATHS.gl.path,
        data: { label: "BREADCRUMBS.GL" },
        loadChildren: () =>
          import("@app/features/general-ledger/general-ledger.module").then(m => m.GeneralLedgerModule),
      },
      {
        path: PATHS.captives.path,
        data: { label: "BREADCRUMBS.CAPTIVES" },
        loadChildren: () =>
          import("@app/features/captive-management/captive-management.module").then(m => m.CaptiveManagementModule),
      },
      {
        path: PATHS.tasks.path,
        data: { label: "BREADCRUMBS.TASKS" },
        loadChildren: () => import("@app/features/tasks/tasks.module").then(m => m.TasksModule),
      },
      {
        path: PATHS.reporting.path,
        data: { label: "BREADCRUMBS.REPORTING" },
        loadChildren: () => import("@app/features/reporting/reporting.module").then(m => m.ReportingModule),
      },
      {
        path: "not-found",
        component: NotFoundComponent,
        data: { label: "BREADCRUMBS.NOT_FOUND" },
      },
    ],
  },
  {
    path: PATHS.auth.path,
    loadChildren: () => import("@app/features/auth/auth.module").then(m => m.AuthModule),
  },
  {
    path: `${PATHS.oauth.path}/${PATHS.oauth.consent.path}`,
    canActivate: [AuthGuard],
    loadComponent: () =>
      import("@app/features/oauth/pages/consent/consent.component").then(c => c.ConsentComponent),
  },
  {
    path: "**",
    redirectTo: "/not-found",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class UnderUiRoutingModule {}
